import "./Modal.scss";
import { IoClose } from "react-icons/io5";

const Modal = ({
    isOpen = false,
    onClose,
    position = "center",
    className = "",
    children,
    actions,
    title = "",
}) => {
    if (!isOpen) return null;

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    const modalClasses = `modal modal--${position} ${className}`;

    return (
        <div className="modal-overlay" onClick={handleOverlayClick}>
            <div className={modalClasses} onClick={(e) => e.stopPropagation()}>
                <div className="modal__header">
                    <h2 className="modal__title">{title}</h2>
                    <button className="modal__close" onClick={onClose}>
                        <IoClose />
                    </button>
                </div>
                <div className="modal__content">{children}</div>
                {actions && <div className="modal__actions">{actions}</div>}
            </div>
        </div>
    );
};

export default Modal;
